(function () {
  'use strict';

  if (window.FellinoraLibraryBlogLoaded) {
    return;
  }

  window.FellinoraLibraryBlogLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initReveal(section) {
    var items = section.querySelectorAll('[data-flb-reveal]');

    items.forEach(function (item, index) {
      item.style.setProperty('--flb-delay', Math.min(index * 90, 540) + 'ms');
    });

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('flb-is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('flb-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.14,
      rootMargin: '0px 0px -10% 0px'
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initMagnetic(section) {
    if (reduceMotion.matches || !canHover.matches) {
      return;
    }

    section.querySelectorAll('[data-flb-card]').forEach(function (card) {
      var inner = card.querySelector('.flb-card__inner');
      if (!inner) {
        return;
      }

      function resetCard() {
        inner.style.setProperty('--flb-rotate-x', '0deg');
        inner.style.setProperty('--flb-rotate-y', '0deg');
        inner.style.setProperty('--flb-shift-x', '0px');
        inner.style.setProperty('--flb-shift-y', '0px');
        inner.style.setProperty('--flb-glow-x', '50%');
        inner.style.setProperty('--flb-glow-y', '0%');
      }

      card.addEventListener('pointermove', function (event) {
        var rect = card.getBoundingClientRect();
        var relativeX = (event.clientX - rect.left) / rect.width;
        var relativeY = (event.clientY - rect.top) / rect.height;
        var deltaX = (relativeX - 0.5) * 2;
        var deltaY = (relativeY - 0.5) * 2;

        inner.style.setProperty('--flb-rotate-x', (-deltaY * 5) + 'deg');
        inner.style.setProperty('--flb-rotate-y', (deltaX * 7) + 'deg');
        inner.style.setProperty('--flb-shift-x', (deltaX * 8) + 'px');
        inner.style.setProperty('--flb-shift-y', (deltaY * 6) + 'px');
        inner.style.setProperty('--flb-glow-x', (relativeX * 100) + '%');
        inner.style.setProperty('--flb-glow-y', (relativeY * 100) + '%');
      });

      card.addEventListener('pointerleave', resetCard);
      card.addEventListener('blur', resetCard, true);
      resetCard();
    });
  }

  function initSection(section) {
    initReveal(section);
    initMagnetic(section);
  }

  function init() {
    document.querySelectorAll('[data-flb-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-flb-section]');
    if (section) {
      initSection(section);
    }
  });
})();
